var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "head" }, [
    _c(
      "ul",
      { staticClass: "tab-list-wrapper" },
      _vm._l(_vm.tabList, function(tab, index) {
        return _c(
          "li",
          {
            key: index,
            staticClass: "tab __pointer",
            class: { active: _vm.$route.name === tab },
            on: {
              click: function($event) {
                return _vm._go(tab)
              }
            }
          },
          [
            _vm._v(
              "\n            " + _vm._s(_vm.$t(tab + ".title")) + "\n        "
            )
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "right-lab-list" },
      [
        _c("SwitchComp", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.$route.name.indexOf("trade") !== -1,
              expression: "$route.name.indexOf('trade') !== -1"
            }
          ],
          staticClass: "tab __pointer invite-switch",
          attrs: { optList: _vm.inviteOptLit, value: _vm.selectInvite },
          on: { input: _vm.inviteDialog }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.$route.name.indexOf("trade") === -1,
                expression: "$route.name.indexOf('trade') === -1"
              }
            ],
            staticClass: "tab __pointer",
            on: { click: _vm.goAnnouncements }
          },
          [_vm._v(_vm._s(_vm.$t("announcements")))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.$route.name.indexOf("trade") === -1,
                expression: "$route.name.indexOf('trade') === -1"
              }
            ],
            staticClass: "tab __pointer",
            on: { click: _vm.goHelp }
          },
          [_vm._v(_vm._s(_vm.$t("help")))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isHaveUsers,
                expression: "!isHaveUsers"
              }
            ],
            staticClass: "tab __pointer",
            on: { click: _vm.login }
          },
          [_vm._v(" " + _vm._s(_vm.$t("login")))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isLogin && _vm.isHaveUsers,
                expression: "!isLogin && isHaveUsers"
              }
            ],
            staticClass: "tab __pointer",
            on: { click: _vm._unlock }
          },
          [_vm._v(_vm._s(_vm.$t("unlockAcc")))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isLogin && _vm.isHaveUsers,
                expression: "!isLogin && isHaveUsers"
              }
            ],
            staticClass: "tab __pointer",
            on: { click: _vm.changeAcc }
          },
          [_vm._v(_vm._s(_vm.$t("changeAcc")))]
        ),
        _vm._v(" "),
        _c("SwitchComp", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.$route.name.indexOf("trade") !== -1,
              expression: "$route.name.indexOf('trade') !== -1"
            }
          ],
          staticClass: "more-switch tab __pointer",
          attrs: { title: _vm.$t("trade.more"), optList: _vm.moreOptList },
          on: { input: _vm.operateAction }
        }),
        _vm._v(" "),
        _c("switch-addr", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.$route.name !== "assets",
              expression: "$route.name !== 'assets'"
            }
          ],
          staticClass: "switch-tab menu"
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isLogin,
                expression: "isLogin"
              }
            ],
            staticClass: "tab __pointer",
            on: { click: _vm.logout }
          },
          [_vm._v(_vm._s(_vm.$t("saveLogout")))]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }